export default "__VITE_ASSET__IPy7Q92a__"